import React from 'react';
import { ThemeProvider } from 'styled-components';
export const UILibraryThemeProvider = (props) => React.createElement(ThemeProvider, Object.assign({}, props));
